import React, { Component } from 'react';
import { Form, Button, Divider, InputNumber } from 'antd'

class LabATM extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toWithdrawValue: 0,
            slots: [
                { type: 100, count: 800 },
                { type: 1000, count: 500 },
                { type: 500, count: 200 },
            ],
            withdrawResults: [],
            withdrawLeftOver: 0,
        };
    }

    onFinish = (values) => {

        var withdrawAmt = values.amount;
        var results = [];

        var newSlots = [...this.state.slots]

        newSlots.sort(function (a, b) {
            return parseInt(b.type) - parseInt(a.type)
        })

        newSlots.forEach(slot => {

            if (withdrawAmt <= 0 || withdrawAmt < slot.type)
                return

            const countToWithdraw = Math.min(Math.floor(withdrawAmt / slot.type), slot.count);
            const amountToWithdraw = countToWithdraw * slot.type;
            withdrawAmt -= amountToWithdraw;
            slot.count -= countToWithdraw;

            results.push({ type: slot.type, count: countToWithdraw })
        })

        this.setState({ toWithdrawValue: 0, withdrawResults: results, withdrawLeftOver: withdrawAmt });
    }


    render() {
        return (<div style={{ padding: "10px", width: "200px", height: "auto", margin: "10px", border: "1px dashed lightgray" }}>
            {this.state.slots.map((slot) => {
                return <div>{`${slot.type} : ${slot.count}`}</div>
            })}
            <Form onFinish={this.onFinish}>
                <Form.Item name="amount" label="Amount" rules={[{ required: true }]} >
                    <InputNumber type="number" value={this.state.toWithdrawValue} onChange={(value) => { this.setState({ toWithdrawValue: value }) }}></InputNumber>
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit">Withdraw</Button>
                </Form.Item>
            </Form>
            <Divider></Divider>
            {this.state.withdrawResults.length > 0 ? (`Withdrawn Money`) : null}

            {this.state.withdrawResults.map((slot) => {
                return <div>{`${slot.type} : ${slot.count}`}</div>
            })}

            <Divider></Divider>
            {this.state.withdrawLeftOver > 0 ? (`Cannot Withdraw : ${this.state.withdrawLeftOver}`) : null}
        </div>
        );
    }
}

export default LabATM;